import DateFnsUtils from '@date-io/date-fns';
import {Button, Divider} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {Title} from 'components/forms';
import {Loading} from 'components/grid-dx/loading/loading';
import {i18n2} from 'features/i18n/i18n';
import {Field, Form, Formik} from 'formik';
import {KeyboardDatePicker} from 'formik-material-ui-pickers';
import {TextField} from 'formik-material-ui';
import authFetch from 'helpers/requests';
import React from 'react';
import {useSelector} from 'react-redux';
import useUtilInformation from 'components/hooks/useUtilInformation';
//Revisar esto, hay que arreglarlo!
//Envia el id y no sirve.. hacerlo async.. (Mas adelante)
interface ReportDateProps {
  openReport: boolean;
  setOpenReport: any;
  selection: string;
  integrityName: string;
  integrityId: any;
}

function ReportDate({
  openReport,
  setOpenReport,
  selection,
  integrityName,
  integrityId,
}: ReportDateProps) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const {cwid} = useUtilInformation();
  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const submit = (values: any, formikBag: any) => {
    //Revisar esto
    setLoading(true);
    setErrorMessage('');
    const signature = {
      user: values.user,
      pass: values.pass,
      reason: values.reason,
    };
    values = {
      ...values,
      selection,
      tableName: integrityName,
      keyName: integrityId,
      signature: JSON.stringify(signature),
    };
    let options = new URLSearchParams();
    options.append('values', JSON.stringify(values));
    return authFetch(
      `api/report/Integrity?${options}`,
      {
        method: 'GET',
        headers: {
          ContentType: 'application/json; charset=utf-8',
        },
      },
      token,
    )
      .then(async (response: any) => {
        if (!response.ok) {
          const message = await response.text();
          throw new Error(message || 'Error generando el reporte');
        }
        return response.blob();
      })
      .then((x: any) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var file = new Blob([x], {type: 'application/pdf'});
          window.navigator.msSaveOrOpenBlob(
            file,
            integrityName + i18n2._(`_reporte.pdf`),
          );
          handleClose();
        } else {
          const fileURL = URL.createObjectURL(x);
          var winparams =
            'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
          window.open(fileURL, 'Reporte', winparams);
          handleClose();
        }
      })
      .catch((e) => {
        setErrorMessage(e.message);
        setLoading(false);
        formikBag.setSubmitting(false);
      });
  };

  const handleClose = () => {
    setOpenReport(false);
    setLoading(false);
    setErrorMessage('');
  };

  return (
    <React.Fragment>
      <Dialog
        open={openReport}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title">
        <Title
          onClose={handleClose}
          title={i18n2._('Reporte de integritdad de datos')}
        />
        <Divider />
        <DialogContent>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
              initialValues={{
                initialDate: startOfMonth,
                finalDate: endOfMonth,
                user: cwid,
                pass: '',
                reason: '',
              }}
              enableReinitialize
              onSubmit={submit}>
              {(formikProps) => {
                return (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="initialDate"
                          component={KeyboardDatePicker}
                          label={i18n2._('Fecha inicial')}
                          fullWidth
                          inputVariant="outlined"
                          disableToolbar
                          variant="inline"
                          views={['year', 'month', 'date']}
                          format="dd/MM/yyyy"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="finalDate"
                          component={KeyboardDatePicker}
                          label={i18n2._('Fecha final')}
                          fullWidth
                          inputVariant="outlined"
                          disableToolbar
                          variant="inline"
                          views={['year', 'month', 'date']}
                          format="dd/MM/yyyy"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          name="reason"
                          component={TextField}
                          label={i18n2._('Motivo')}
                          fullWidth
                          variant="outlined"
                          FormHelperTextProps={{style: {minHeight: 20}}}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validate={(value: any) => {
                            let error;
                            if (
                              !value ||
                              (typeof value !== 'undefined' &&
                                value.length === 0)
                            ) {
                              error = i18n2._('Por favor ingrese un motivo');
                            }
                            return error;
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="user"
                          component={TextField}
                          label={i18n2._('Usuario')}
                          fullWidth
                          variant="outlined"
                          disabled
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Field
                          name="pass"
                          component={TextField}
                          label={i18n2._('Contraseña')}
                          fullWidth
                          type="password"
                          variant="outlined"
                          FormHelperTextProps={{style: {minHeight: 20}}}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          validate={(value: any) => {
                            let error;
                            if (
                              !value ||
                              (typeof value !== 'undefined' &&
                                value.length === 0)
                            ) {
                              error = i18n2._(
                                'Por favor ingrese su contraseña',
                              );
                            }
                            return error;
                          }}
                        />
                      </Grid>
                      {errorMessage && (
                        <Grid item xs={12}>
                          <div style={{color: 'red', float: 'right'}}>
                            {errorMessage}
                          </div>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <div style={{float: 'right', marginBottom: '10px'}}>
                          <Button
                            onClick={() => handleClose()}
                            className="red-text">
                            {i18n2._('Cancelar')}
                          </Button>
                          <Button
                            type="submit"
                            color="primary"
                            disabled={formikProps.isSubmitting}>
                            {i18n2._('Crear reporte')}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </MuiPickersUtilsProvider>
        </DialogContent>
        {loading && <Loading />}
      </Dialog>
    </React.Fragment>
  );
}

export default ReportDate;
